import { render, staticRenderFns } from "./featuredListingTab.vue?vue&type=template&id=1a4d3e27&scoped=true&"
import script from "./featuredListingTab.vue?vue&type=script&lang=js&"
export * from "./featuredListingTab.vue?vue&type=script&lang=js&"
import style0 from "./featuredListingTab.vue?vue&type=style&index=0&id=1a4d3e27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d3e27",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon,QInput,QTd,QTooltip});
